var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.config.ui_version == '3.8')?_c('subgame3Dian8'):_c('subgame')
}
var staticRenderFns = []

export { render, staticRenderFns }